"use strict";const o=require("styled-components").css`
    background-color: ${({background:o})=>o||"rgba(0, 117, 201, 0.1)"};
    border-radius: 4px;
    max-width: fit-content;
    font-weight: 600;
    color: ${({color:o,theme:r})=>o||r.colors.primary.default};
    padding: 8px;
`;module.exports=o;
//# sourceMappingURL=styles.js.map
